import { GridColDef } from "@mui/x-data-grid";
import SettingsIcon from "@mui/icons-material/Settings";
import { Box, Chip } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import CustomDataGrid from "../../../components/ui/customDataGrid/customDataGrid.component";
import { EQUIPMENT_ATTRIBUTES_ENDPOINT } from "../../../consts";
import { useHasPermission } from "../../../contexts/auth";
import {
  containsStringFilterOperators,
  equalsNumberFilterOperators,
} from "../../../components/ui/customDataGrid/filterOperators";

export default function ConfigurationsList() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const canViewConfigurations = useHasPermission("settlement.view_equipmentattribute");

  const columns: GridColDef[] = [
    { field: "id", headerName: "ID", width: 90, filterOperators: equalsNumberFilterOperators() },
    { field: "name", headerName: t("Name"), width: 150, filterOperators: containsStringFilterOperators() },
    {
      field: "choices",
      headerName: t("Choices"),
      width: 520,
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const choices = params.row.choices;
        if (!Array.isArray(choices) || choices.length === 0) return "—";

        return (
          <Box sx={{ display: "flex", flexWrap: "wrap", gap: 0.5 }}>
            {choices.map((c: { id?: number; name?: string }, idx: number) => (
              <Chip
                key={c.id ?? idx}
                label={c.name ?? ""}
                size="small"
                variant="outlined"
              />
            ))}
          </Box>
        );
      },
      valueGetter: (_value, row) => {
        const choices = row.choices;
        if (!Array.isArray(choices) || choices.length === 0) return "";
        return choices.map((c: { name?: string }) => c.name ?? "").join(", ");
      },
    },
  ];

  const handleRowClick = (id: string) => {
    navigate(`/equipment-section/configurations/${id}`);
  };

  if (!canViewConfigurations) {
    return null;
  }

  return (
    <CustomDataGrid
      icon={<SettingsIcon />}
      title={t("Configurations")}
      url={EQUIPMENT_ATTRIBUTES_ENDPOINT}
      gridSettingsKey="EQUIPMENT_CONFIGURATIONS"
      columns={columns}
      refreshEventName="equipmentAttributeAdded"
      onRowClick={handleRowClick}
    />
  );
}
